import { render, staticRenderFns } from "./DialogAddStaff.vue?vue&type=template&id=31e2ebb4&scoped=true"
import script from "./DialogAddStaff.vue?vue&type=script&lang=js"
export * from "./DialogAddStaff.vue?vue&type=script&lang=js"
import style0 from "./DialogAddStaff.vue?vue&type=style&index=0&id=31e2ebb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e2ebb4",
  null
  
)

export default component.exports